import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'confirm-dialog',
    template: `
    <div class="confirm-dialog">
      <h1 class="confirm-dialog-title">
        {{ data?.title || 'Dialog' }}
      </h1>

      <mat-dialog-content class="confirm-dialog-content">
        {{ data?.message || 'Are you sure to do this?' }}
      </mat-dialog-content>

      <mat-dialog-actions class="confirm-dialog-actions">
        <button mat-raised-button [mat-dialog-close]="ACTION_CONFIRM" color="primary">
          {{ data?.confirmText || 'Confirm' }}
        </button>
        <button mat-stroked-button [mat-dialog-close]="ACTION_CANCEL" color="warn">
          {{ data?.cancelText || data?.cancelButtonText || 'Cancel' }}
        </button>
      </mat-dialog-actions>
    </div>
  `,
    styles: [
        `
      .confirm-dialog {
        min-width: 350px;
        font-family: sans-serif;
        padding: 16px;
      }

      .confirm-dialog-title {
        margin: 0 0 12px 0;
        font-size: 20px;
        font-weight: 500;
      }

      .confirm-dialog-content {
        padding: 8px 0 20px 0;
        font-size: 15px;
        color: #444;
      }

      .confirm-dialog-actions {
        display: flex;
        justify-content: flex-end;
        gap: 12px;
        padding-top: 8px;
      }
    `,
    ]
})
export class ConfirmDialog {
    // dialogActions: string;
    public readonly ACTION_YES: string = "YES";
    public readonly ACTION_NO: string = "NO";
    public readonly ACTION_CANCEL: string = "CANCELED";
    public readonly ACTION_IGNORE: string = "IGNORED";
    public readonly ACTION_OK: string = "OK";
    public readonly ACTION_CLOSE: string = "CLOSED";
    public readonly ACTION_CONFIRM: string = "CONFIRMED";

    constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<ConfirmDialog>) {


    }
}
